import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { TeamComponent } from '../../shared/components/team/team.component';
import { PartnersComponent } from '../../shared/components/partners/partners.component';
import { ContactFormComponent } from '../../shared/components/contact-form/contact-form.component';
import { SpecialistsNetworkComponent } from "../../shared/components/specialists-network/specialists-network.component";

@Component({
    selector: 'app-about',
    imports: [
        TeamComponent,
        PartnersComponent,
        ContactFormComponent,
        SpecialistsNetworkComponent
    ],
    templateUrl: './about.component.html',
    styleUrl: './about.component.css',
    standalone: true
})
export default class AboutComponent implements AfterViewInit, OnDestroy {
    @ViewChild('aboutSection') aboutSection!: ElementRef;

    isVisible = false;
    private observer: IntersectionObserver | null = null;

    ngAfterViewInit(): void {
        // Pequeño delay para asegurar que el DOM esté listo
        setTimeout(() => {
            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            this.isVisible = true;
                            // Desconectamos para que la animación solo ocurra una vez
                            if (this.observer) {
                                this.observer.disconnect();
                            }
                        }
                    });
                },
                {
                    threshold: 0.15, // Se activa cuando el 15% de la sección es visible
                    rootMargin: '0px 0px -50px 0px' // Margen para que se active un poco antes
                }
            );

            if (this.aboutSection?.nativeElement) {
                this.observer.observe(this.aboutSection.nativeElement);
            }
        }, 100);
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}